import { SvgIcon } from '@material-ui/core';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import React, { FC } from 'react';

import { IconTypes } from 'src/types';

export type IncompleteProps = SvgIconProps;

export const Incomplete: FC<IncompleteProps> = props => (
  <SvgIcon aria-label={IconTypes.INCOMPLETE} {...props}>
    <g clipPath="url(#clip0_24_332)">
      <path d="M12 0C9.62661 0 7.30654 0.703788 5.33315 2.02236C3.35976 3.34094 1.82169 5.21509 0.913436 7.4078C0.00518411 9.60051 -0.232456 12.0133 0.230567 14.3411C0.693589 16.6689 1.83648 18.8071 3.51471 20.4853C5.19294 22.1635 7.33113 23.3064 9.65891 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0866C18.7849 22.1783 20.659 20.6402 21.9776 18.6668C23.2962 16.6935 24 14.3734 24 12C24 8.8174 22.7357 5.76516 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0V0ZM2.99999 12C2.99999 9.61305 3.9482 7.32387 5.63603 5.63604C7.32386 3.94821 9.61304 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12H2.99999Z" />
    </g>
  </SvgIcon>
);
